module.exports = __webpack_public_path__ + "img/nz.131d3f29.svg";